(function () {
  const desktopHover = window.matchMedia(
    "(min-width: 990px) and (hover: hover) and (pointer: fine)"
  );
  let cleanups = [];

  const listen = (element, eventName, callback) => {
    if (!element) return;
    element.addEventListener(eventName, callback);
    cleanups.push(() => element.removeEventListener(eventName, callback));
  };

  const clearSetup = () => {
    cleanups.forEach((cleanup) => cleanup());
    cleanups = [];
  };

  const setupHoverPanels = () => {
    clearSetup();

    const header = document.querySelector(".header[data-hover-panels='true']");
    if (!header || !desktopHover.matches || window.Shopify?.designMode) return;

    const openDelay = Number(header.dataset.hoverOpenDelay) || 250;
    const closeDelay = Number(header.dataset.hoverCloseDelay) || 600;
    const cartTrigger = header.querySelector("#cart-icon-bubble");
    const cartDrawer = document.querySelector("cart-drawer");
    const cartPanel = cartDrawer?.querySelector(".cart-drawer__inner");
    const cartOverlay = cartDrawer?.querySelector(".cart-drawer__overlay");
    let cartOpenTimer;
    let cartCloseTimer;

    const clearCartTimers = () => {
      window.clearTimeout(cartOpenTimer);
      window.clearTimeout(cartCloseTimer);
    };

    const openCart = () => {
      clearCartTimers();
      cartOpenTimer = window.setTimeout(() => {
        if (!cartDrawer || !cartTrigger || cartDrawer.classList.contains("modal--open")) return;
        cartDrawer.dataset.openedByHover = "true";
        cartDrawer.open?.(cartTrigger);
      }, openDelay);
    };

    const scheduleCartClose = () => {
      window.clearTimeout(cartOpenTimer);
      window.clearTimeout(cartCloseTimer);
      if (cartDrawer?.dataset.openedByHover !== "true") return;
      cartCloseTimer = window.setTimeout(() => {
        cartDrawer.close?.();
        delete cartDrawer.dataset.openedByHover;
      }, closeDelay);
    };

    listen(cartTrigger, "mouseenter", openCart);
    listen(cartTrigger, "mouseleave", scheduleCartClose);
    listen(cartTrigger, "click", () => {
      clearCartTimers();
      if (cartDrawer) delete cartDrawer.dataset.openedByHover;
    });
    listen(cartPanel, "mouseenter", clearCartTimers);
    listen(cartPanel, "mouseleave", scheduleCartClose);
    listen(cartOverlay, "mouseenter", scheduleCartClose);

    const accountComponent = header.querySelector(".header__account shopify-account");
    let accountTimer;
    let accountTriggered = false;

    const openAccount = () => {
      window.clearTimeout(accountTimer);
      if (accountTriggered || !accountComponent) return;
      accountTimer = window.setTimeout(() => {
        const signedOutTrigger = accountComponent.querySelector("[slot='signed-out-avatar']");
        const componentTrigger = accountComponent.shadowRoot?.querySelector(
          "button, [role='button']"
        );
        (signedOutTrigger || componentTrigger || accountComponent).click();
        accountTriggered = true;
      }, openDelay);
    };

    const resetAccountHover = () => {
      window.clearTimeout(accountTimer);
      window.setTimeout(() => {
        accountTriggered = false;
      }, closeDelay);
    };

    listen(accountComponent, "mouseenter", openAccount);
    listen(accountComponent, "mouseleave", resetAccountHover);
  };

  document.addEventListener("DOMContentLoaded", setupHoverPanels);
  document.addEventListener("shopify:section:load", setupHoverPanels);
  desktopHover.addEventListener?.("change", setupHoverPanels);
})();
